// dependencies
import React, { useState } from 'react'

// components
import { Button, BUTTON_THEME, Icon } from '@st-operations/uikit/src/v2/index.js'
import ListView from '_components/list-view/index.jsx'
import MoreInfoDropdown from '../../components/more-info-dropdown/index.jsx'
import PartnerBrandedAudiencesModal from '../../components/partner-branded-audiences-modal/index.jsx'
import { Dialog3 as Dialog } from '@st-operations/uikit/src/v1/index.js'
import ImportAudiencesModal from './import-audiences-modal/index.jsx'
import ImportAudiencesProcessModal from './import-audiences-process-modal/index.jsx'
import OnClickOutside from '../../components/OnClickOutside.jsx'
import Header from '_components/header/index.jsx'

const CHECKED_ICON = '../../../static/img/checked.svg'
const UNCHECKED_ICON = '../../../static/img/unchecked.svg'

// css
import './styles.scss'

const BUTTON_STYLE = {
  color: '#1f1f1f',
  fontWeight: 'normal',
  fontSize: '14px',
  justifyContent: 'flex-start',
  lineHeight: '24px',
  margin: 0,
}

const syncOptions = [
  { name: 'TTD Global', field: 'sync_ttd_global' },
  { name: 'TTD US', field: 'sync_ttd_us' },
  { name: 'AppNexus Global', field: 'sync_appnexus_global' },
  { name: 'AppNexus US', field: 'sync_appnexus_us' },
]

const PartnerBrandedAudiences = () => {
  const [dropdownOpen, setDropdownOpen] = useState(false)
  const [showAudienceModal, setShowAudienceModal] = useState(false)
  const [importAudience, setImportAudience] = useState(false)
  const [showInfo, setShowInfo] = useState(false)
  const [importAudiencesProcessModal, setImportAudiencesProcessModal] = useState(false)

  const toggleDropdown = () => {
    setDropdownOpen((prevstate) => !prevstate)
  }

  const handleImportAudience = () => {
    setImportAudience((prevstate) => !prevstate)
  }

  const handleShowAudienceModal = () => {
    setShowAudienceModal((prevstate) => !prevstate)
  }

  const handleShowInfo = () => {
    setShowInfo((prevstate) => !prevstate)
  }

  const handleImportAudiencesProcessModal = () => {
    setImportAudiencesProcessModal((prevstate) => !prevstate)
  }

  const handleCancelProcessModal = () => {
    // TODO
  }

  const renderOptions = (pba) => {
    return syncOptions.map((option) => (
      <div key={option.field} className="partner-branded-audiences__checkmark-row">
        <img
          className="version-control__checkmark-icon"
          src={pba[option.field] ? CHECKED_ICON : UNCHECKED_ICON}
        />
        <p className="partner-branded-audiences__checkmark-label">{option.name}</p>
      </div>
    ))
  }

  return (
    <div id="partner-branded-audiences">
      <Header
        title="Partner Branded Audiences"
        actions={[
          {
            theme: BUTTON_THEME.GHOST,
            children: (
              <div className="partner-branded-audiences__save-button">
                <Button
                  onClick={handleShowAudienceModal}
                  className="partner-branded-audiences__save-text"
                >
                  <span>Create New</span>
                </Button>
                <Button
                  onClick={toggleDropdown}
                  className="partner-branded-audiences__save-select"
                  aria-label="Open save options"
                >
                  <Icon
                    type="fill"
                    icon="angledown"
                    className="partner-branded-audiences__save-select-icon"
                  />
                </Button>
              </div>
            ),
          },
          {
            theme: BUTTON_THEME.GHOST,
            children: <Icon icon="info" />,
            onClick: handleShowInfo,
          },
        ]}
        className="partner-branded-audiences__header"
      >
        <div className="partner-branded-audiences__header-container">
          <If condition={dropdownOpen}>
            <OnClickOutside onClickOutside={toggleDropdown}>
              <div className="partner-branded-audiences__dropdown">
                <Button
                  theme={BUTTON_THEME.GHOST}
                  onClick={handleShowAudienceModal}
                  className="partner-branded-audiences__dropdown-button"
                  style={BUTTON_STYLE}
                >
                  Create New Audience
                </Button>
                <Button
                  theme={BUTTON_THEME.GHOST}
                  onClick={handleImportAudience}
                  className="partner-branded-audiences__dropdown-button"
                  style={BUTTON_STYLE}
                >
                  Import Audience
                </Button>
              </div>
            </OnClickOutside>
          </If>
        </div>
      </Header>
      <ImportAudiencesModal
        isOpen={importAudience}
        onClose={handleImportAudience}
        onImport={handleImportAudiencesProcessModal}
      />
      <If condition={importAudiencesProcessModal}>
        <ImportAudiencesProcessModal
          title="Import Audiences"
          subtitle="This process will be done in a few seconds."
          isOpen={importAudiencesProcessModal}
          onCancel={handleCancelProcessModal}
          // percentage={batch_percentage}
        />
      </If>
      <If condition={showInfo}>
        <MoreInfoDropdown onClose={handleShowInfo} />
      </If>
      <Dialog open={showAudienceModal} close={handleShowAudienceModal}>
        <PartnerBrandedAudiencesModal onClose={handleShowAudienceModal} />
      </Dialog>
      <div>
        <div>
          <ListView
            className="partner-branded-audiences__list-view"
            inputClassName="partner-branded-audiences__list-view-input"
            columns={[
              {
                name: 'Name',
                key: 'name',
                link: `/partner-branded-audiences/:_id`,
                sortable: true,
              },
              {
                key: 'sync',
                name: 'Sync',
                sortable: true,
                render: renderOptions,
              },
              {
                key: 'global_id',
                name: 'Global ID',
                sortable: true,
              },
              {
                key: 'us_id',
                name: 'US ID',
                sortable: true,
              },
              {
                key: 'created_by.email',
                name: 'Created by',
                sortable: true,
              },
            ]}
            entities="partner-branded-audiences"
            fields={[
              'name',
              'sync_appnexus_global',
              'sync_appnexus_us',
              'sync_ttd_global',
              'sync_ttd_us',
              'global_id',
              'us_id',
              'created_by',
            ]}
            searchable={true}
            sort_dir={1}
            sort_key={'name'}
          />
        </div>
      </div>
    </div>
  )
}

export default PartnerBrandedAudiences
